// src/components/PrivateRoute.jsx
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

export default function PrivateRoute({ children }) {
  const { isAuthenticated, authLoading } = useContext(AuthContext);

  // Still checking token / refresh
  if (authLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white text-gray-700">
        <p className="text-sm">Loading…</p>
      </div>
    );
  }

  // Not logged in → bounce to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated → render the protected page
  return children;
}
